export default __webpack_public_path__ + "static/media/faq.a3cbf101.jpg";